module.exports = __webpack_public_path__ + "img/img_actbar_mini@2x.492c0647.png";